import {
  Grid,
  Divider,
  TextField,
} from "@mui/material";
import { flexiblePhoneMask, TextMaskCustom } from "../utils/masks";
import { FieldLabel, SectionTitle, fieldStyle } from "./profileFormStyles";

const ContactSection = ({
  formData,
  errors,
  handleChange
}) => {
  return (
    <Grid container columnSpacing={2} rowSpacing={2.25} sx={{ mt: 2 }}>
      <Grid item xs={12}>
        <SectionTitle>Administrador</SectionTitle>
      </Grid>

      <Grid item xs={12} md={6}>
        <FieldLabel>E-mail *</FieldLabel>
        <TextField
          fullWidth
          required
          name="email"
          error={!!errors.email}
          helperText={errors.email}
          value={formData.email}
          onChange={handleChange}
          sx={fieldStyle}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FieldLabel>Telefone comercial *</FieldLabel>
        <TextField
          fullWidth
          required
          name="telephone"
          error={!!errors.telephone}
          helperText={errors.telephone}
          value={formData.telephone}
          onChange={handleChange}
          sx={fieldStyle}
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: { mask: flexiblePhoneMask },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FieldLabel>Celular / WhatsApp *</FieldLabel>
        <TextField
          fullWidth
          required
          name="cellphone"
          error={!!errors.cellphone}
          helperText={errors.cellphone}
          value={formData.cellphone}
          onChange={handleChange}
          sx={fieldStyle}
          InputProps={{
            inputComponent: TextMaskCustom,
            inputProps: { mask: flexiblePhoneMask },
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <Divider sx={{ borderColor: "#e2e8f0", mt: 1.25 }} />
      </Grid>
    </Grid>
  );
};

export default ContactSection;
